import React from "react";
import { ProjectIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import { CompanyIcon, FolderIcon } from "@netapp/bxp-style/react-icons/General"
import { StyledLink, withTextOverflow } from "@netapp/bxp-design-system-react";
import styles from "../modules/app/components/MainHeader.module.scss";

export const StyledLinkWithOverflow = ({ className, children, to, ...props }) => {
    const Component = withTextOverflow(StyledLink);

    return (
        <div>
            <Component
                to={to}
                variant="text"
                className={className}
                style={{ display: "inline-block" }}
                {...props}
            >
                {children}
            </Component>
        </div>
    );
};

export const IAMResourceIconRenderer = (element) => {
    if (element.resourceType === "organization") {
        return <CompanyIcon className={element?.isSelected ? "" : styles["tenancy-icon-color"]} width="20" />
    } else if (element.resourceType === "folder") {
        return <FolderIcon className={element?.isSelected ? "" : styles["tenancy-icon-color"]} width="20" />
    } else if (element.resourceType === "project") {
        return <ProjectIcon className={element?.isSelected ? "" : styles["tenancy-icon-color"]} width="20" />
    }
    return null
}